import { api } from './api';

/**
 * Resumo do ciclo dos liderados de um gestor (aggregate `equipe_resumo`, spec `minha-equipe-nova-identidade`).
 * O servidor decide o ciclo vigente e o ciclo fechado dos selos; aqui só se normaliza a resposta.
 */

export interface RealizacaoResumo {
  _id: string;
  title: string;
  status: string;
  /** Data de cadastro em milissegundos. */
  created: number;
}

export interface ReconhecimentosPorTipo {
  valeu: number;
  mandou: number;
  uau: number;
}

export interface MembroResumo {
  chave: string;
  tipo_de_acordo?: string;
  pontos: number;
  selos: number;
  reconhecimentos: ReconhecimentosPorTipo;
  realizacoes: RealizacaoResumo[];
}

export interface CicloDoResumo {
  titulo: string;
  inicio: number;
  fim: number;
}

export interface EquipeResumo {
  ciclo: CicloDoResumo;
  /** Título do último ciclo fechado (selos), ou null quando não há um válido. */
  cicloSelos: string | null;
  membros: MembroResumo[];
}

type MongoDate = number | string | { $date: number | string };

function emMilissegundos(data: MongoDate | undefined): number {
  if (typeof data === 'number') return data;
  const valor = typeof data === 'object' && data !== null ? data.$date : data;
  return typeof valor === 'number' ? valor : Date.parse(String(valor));
}

function normalizarMembro(membro: any): MembroResumo {
  const reconhecimentos = membro.reconhecimentos ?? {};
  return {
    chave: membro.chave,
    ...(membro.tipo_de_acordo !== undefined && { tipo_de_acordo: membro.tipo_de_acordo }),
    pontos: membro.pontos ?? 0,
    selos: membro.selos ?? 0,
    reconhecimentos: {
      valeu: reconhecimentos.valeu ?? 0,
      mandou: reconhecimentos.mandou ?? 0,
      uau: reconhecimentos.uau ?? 0,
    },
    realizacoes: (membro.realizacoes ?? []).map((realizacao: any) => ({
      _id: realizacao._id,
      title: realizacao.title,
      status: realizacao.status,
      created: emMilissegundos(realizacao.created),
    })),
  };
}

/** Uma chamada por gestor visto. Falha ou resposta sem documento devolve null (métricas indisponíveis). */
export async function getEquipeResumo(player: string): Promise<EquipeResumo | null> {
  try {
    const { data } = await api.post('find/equipe_resumo', { player });
    const documento = Array.isArray(data) ? data[0] : undefined;
    if (!documento?.ciclo) return null;

    return {
      ciclo: documento.ciclo,
      cicloSelos: documento.cicloSelos ?? null,
      membros: (documento.membros ?? []).map(normalizarMembro),
    };
  } catch {
    return null;
  }
}
